import React, { useState } from 'react'
import { i18n } from '../../domain/index'
import { isConnectedToInternet } from '../utils'

const useNavigatorOnLine = () => {
  const [status, setStatus] = useState(isConnectedToInternet())
  const setOnline = () => setStatus(true)
  const setOffline = () => setStatus(false)

  React.useEffect(() => {
    window.addEventListener('online', setOnline)
    window.addEventListener('offline', setOffline)

    return () => {
      window.removeEventListener('online', setOnline)
      window.removeEventListener('offline', setOffline)
    }
  }, [])

  return status
}

export default function NetworkStatusIndicator() {
  const [showMessage, setShowMessage] = useState(false)
  const isOnline = useNavigatorOnLine()
  const firstUpdate = React.useRef(true)

  React.useLayoutEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false
      return
    }
    setShowMessage(!isOnline)
  }, [isOnline, showMessage])

  if (!showMessage) {
    return <></>
  }

  return <span>{i18n.t('common.noInternet')}</span>
}
